import styled from 'styled-components';

export const RewardStockContainerStyled = styled.div`
  .filter_layout {
    margin-bottom: 1rem;
  }
  .summary_layout {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 1rem;
    .summary_block {
      min-width: 180px;
      padding: 10px 16px;
      border-radius: 8px;
      background: ${({ theme }) => theme.COLORS.WHITE_1};
      border: 1px solid ${({ theme }) => theme.COLORS.GRAY_1};
      .sb_label {
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
        color: ${({ theme }) => theme.COLORS.GRAY_3};
      }
      .sb_value {
        margin-top: 4px;
        font-size: ${({ theme }) => theme.FONT.SIZE.S18};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
      }
    }
  }
  .body_status {
    display: flex;
    align-items: center;
    .round {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      flex-shrink: 0;
    }
    .label_status {
      margin-left: 6px;
    }
  }
`;
